import React from 'react';
import { motion } from 'framer-motion';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .ev-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .ev-page { font-family: 'Inter', sans-serif; color: #0c1a36; background: #ffffff; width: 100%; }

  .ev-breadcrumb { max-width: 1200px; margin: 0 auto; padding: 24px 24px 0; display: flex; align-items: center; gap: 8px; font-size: 13px; color: #94a3b8; }
  .ev-breadcrumb-btn { background: none; border: none; cursor: pointer; color: #1e4d8c; font-size: 13px; font-weight: 600; padding: 0; display: inline-flex; align-items: center; gap: 5px; transition: color 0.2s; }
  .ev-breadcrumb-btn:hover { color: #c9931a; }

  /* ── Hero ── */
  .ev-hero { position: relative; padding: 60px 24px 100px; overflow: hidden; background: #fff; }
  .ev-hero-blob1 { position: absolute; top: -8%; right: -4%; width: 540px; height: 540px; border-radius: 50%; background: radial-gradient(circle, rgba(220,38,38,0.1), rgba(201,147,26,0.1)); filter: blur(80px); pointer-events: none; }
  .ev-hero-blob2 { position: absolute; bottom: -12%; left: -6%; width: 580px; height: 580px; border-radius: 50%; background: radial-gradient(circle, rgba(12,26,54,0.16), rgba(30,77,140,0.1)); filter: blur(80px); pointer-events: none; }
  .ev-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .ev-hero-inner { grid-template-columns: 1fr; } .ev-hero-right { display: none; } }

  .ev-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 18px; border-radius: 999px; background: #fef3c7; border: 1px solid #fde68a; font-size: 12.5px; font-weight: 600; color: #92400e; margin-bottom: 28px; }
  .ev-hero h1 { font-size: clamp(1.725rem, 3.375vw, 2.85rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0c1a36; margin-bottom: 22px; }
  .ev-gradient { background: linear-gradient(135deg, #1e4d8c 0%, #c9931a 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .ev-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.82; margin-bottom: 36px; max-width: 520px; }
  .ev-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .ev-btn-primary { padding: 14px 28px; background: #0c1a36; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; }
  .ev-btn-primary:hover { background: #1e4d8c; transform: translateY(-1px); }
  .ev-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ev-btn-secondary:hover { border-color: #fde68a; background: #fffbeb; color: #92400e; }

  /* Hero validation card */
  .ev-hero-right { display: flex; flex-direction: column; gap: 14px; }
  .ev-val-card { background: #0c1a36; border-radius: 22px; padding: 30px; position: relative; overflow: hidden; box-shadow: 0 24px 64px rgba(12,26,54,0.3); }
  .ev-val-dots { position: absolute; inset: 0; opacity: 0.07; background-image: radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 0); background-size: 20px 20px; pointer-events: none; }
  .ev-val-header { font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.4); letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 18px; }
  .ev-val-row { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.07); }
  .ev-val-row:last-child { border-bottom: none; }
  .ev-val-icon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }
  .ev-val-icon.ok { background: rgba(16,185,129,0.2); }
  .ev-val-icon.err { background: rgba(220,38,38,0.2); }
  .ev-val-icon.warn { background: rgba(245,158,11,0.2); }
  .ev-val-field { font-size: 12.5px; color: rgba(255,255,255,0.65); flex: 1; }
  .ev-val-status { font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
  .ev-val-status.ok { background: rgba(16,185,129,0.15); color: #34d399; border: 1px solid rgba(16,185,129,0.25); }
  .ev-val-status.err { background: rgba(220,38,38,0.15); color: #f87171; border: 1px solid rgba(220,38,38,0.25); }
  .ev-val-status.warn { background: rgba(245,158,11,0.15); color: #fbbf24; border: 1px solid rgba(245,158,11,0.25); }
  .ev-val-footer { margin-top: 16px; padding: 14px 16px; background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.2); border-radius: 12px; font-size: 12.5px; color: #6ee7b7; line-height: 1.5; }
  .ev-score-card { background: #fff; border-radius: 16px; padding: 18px 22px; box-shadow: 0 4px 16px rgba(12,26,54,0.1); display: flex; align-items: center; gap: 16px; }
  .ev-score-icon { width: 44px; height: 44px; border-radius: 12px; background: #ecfdf5; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
  .ev-score-label { font-size: 11px; color: #94a3b8; font-weight: 500; }
  .ev-score-value { font-size: 15px; font-weight: 800; color: #0c1a36; margin-top: 2px; }

  /* ── Shared ── */
  .ev-section { padding: 88px 24px; }
  .ev-container { max-width: 1200px; margin: 0 auto; }
  .ev-section-header { text-align: center; max-width: 720px; margin: 0 auto 60px; }
  .ev-section-header h2 { font-size: clamp(1.8rem, 3.2vw, 2.7rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; margin-bottom: 14px; line-height: 1.2; }
  .ev-section-header p { font-size: 1.03rem; color: #64748b; line-height: 1.8; }
  .ev-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #1e4d8c; margin-bottom: 12px; }

  /* ── What Validation Is ── */
  .ev-what-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.7); }
  .ev-what-layout { display: grid; grid-template-columns: 1.1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .ev-what-layout { grid-template-columns: 1fr; } }
  .ev-what-left h2 { font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 16px; }
  .ev-what-left > p { font-size: 1rem; color: #475569; line-height: 1.82; margin-bottom: 32px; }
  .ev-sources { display: flex; flex-direction: column; gap: 14px; }
  .ev-source { display: flex; gap: 14px; padding: 16px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; align-items: flex-start; }
  .ev-source-icon { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .ev-source-icon.irs { background: #fef3c7; }
  .ev-source-icon.cage { background: #eff6ff; }
  .ev-source-icon.sam { background: #f0fdfa; }
  .ev-source-icon.state { background: #fdf4ff; }
  .ev-source h5 { font-size: 0.93rem; font-weight: 700; color: #0c1a36; margin-bottom: 4px; }
  .ev-source p { font-size: 0.85rem; color: #64748b; line-height: 1.62; }
  .ev-mismatch-examples { background: #fff; border: 1px solid #e2e8f0; border-radius: 18px; padding: 24px; }
  .ev-mismatch-title { font-size: 12px; font-weight: 700; color: #0c1a36; letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 18px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
  .ev-mismatch-row { display: flex; align-items: flex-start; gap: 10px; padding: 12px 0; border-bottom: 1px solid #f8fafc; }
  .ev-mismatch-row:last-child { border-bottom: none; }
  .ev-mismatch-err { font-size: 11px; font-weight: 700; background: #fef2f2; color: #ef4444; padding: 3px 8px; border-radius: 6px; flex-shrink: 0; margin-top: 1px; }
  .ev-mismatch-desc { font-size: 12px; color: #475569; line-height: 1.62; }

  /* ── Common Error Types (dark) ── */
  .ev-errors-bg { background: #0c1a36; position: relative; overflow: hidden; }
  .ev-errors-glow { position: absolute; top: -8%; right: 18%; width: 480px; height: 480px; background: radial-gradient(circle, rgba(220,38,38,0.12), transparent 70%); pointer-events: none; }
  .ev-errors-bg .ev-kicker { color: #fca5a5; }
  .ev-errors-bg .ev-section-header h2 { color: #fff; }
  .ev-errors-bg .ev-section-header p { color: #94a3b8; }
  .ev-errors-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  @media (max-width: 900px) { .ev-errors-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 580px) { .ev-errors-grid { grid-template-columns: 1fr; } }
  .ev-err-card { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08); border-radius: 18px; padding: 28px; transition: all 0.3s; }
  .ev-err-card:hover { border-color: rgba(220,38,38,0.3); background: rgba(220,38,38,0.06); }
  .ev-err-icon { font-size: 26px; margin-bottom: 14px; }
  .ev-err-card h4 { font-size: 0.97rem; font-weight: 700; color: #fca5a5; margin-bottom: 8px; }
  .ev-err-card p { font-size: 0.87rem; color: #94a3b8; line-height: 1.68; }

  /* ── Our Audit Checklist ── */
  .ev-audit-bg { background: #fff; }
  .ev-audit-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: start; }
  @media (max-width: 900px) { .ev-audit-layout { grid-template-columns: 1fr; } }
  .ev-audit-left h2 { font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 16px; }
  .ev-audit-left p { font-size: 1rem; color: #475569; line-height: 1.82; margin-bottom: 28px; }
  .ev-checklist { display: flex; flex-direction: column; gap: 10px; }
  .ev-check-item { display: flex; align-items: flex-start; gap: 12px; padding: 14px 16px; background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px; transition: all 0.2s; }
  .ev-check-item:hover { background: #fff; border-color: #e2e8f0; box-shadow: 0 4px 12px rgba(0,0,0,0.05); }
  .ev-check-mark { width: 22px; height: 22px; border-radius: 50%; background: #ecfdf5; border: 1.5px solid #bbf7d0; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #059669; flex-shrink: 0; margin-top: 1px; font-weight: 800; }
  .ev-check-item p { font-size: 0.9rem; color: #334155; line-height: 1.65; }
  .ev-process-right { display: flex; flex-direction: column; gap: 16px; }
  .ev-proc-step { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 16px; padding: 22px 24px; display: flex; gap: 16px; align-items: flex-start; transition: all 0.2s; }
  .ev-proc-step:hover { background: #fff; box-shadow: 0 8px 28px rgba(0,0,0,0.07); }
  .ev-proc-num { width: 36px; height: 36px; border-radius: 10px; background: linear-gradient(135deg, #0c1a36, #1e4d8c); color: #fff; font-size: 13px; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .ev-proc-step h5 { font-size: 0.95rem; font-weight: 700; color: #0c1a36; margin-bottom: 5px; }
  .ev-proc-step p { font-size: 0.86rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .ev-cta-bg { background: #fff; border-top: 1px solid #f1f5f9; }
  .ev-cta-inner { background: linear-gradient(135deg, #0c1a36 0%, #1a3568 60%, #0c1a36 100%); border-radius: 28px; padding: 80px 56px; text-align: center; position: relative; overflow: hidden; max-width: 900px; margin: 0 auto; }
  @media (max-width: 640px) { .ev-cta-inner { padding: 52px 28px; border-radius: 20px; } }
  .ev-cta-glow1 { position: absolute; top: -20%; right: -5%; width: 350px; height: 350px; background: radial-gradient(circle, rgba(201,147,26,0.22), transparent 65%); pointer-events: none; }
  .ev-cta-glow2 { position: absolute; bottom: -20%; left: -5%; width: 350px; height: 350px; background: radial-gradient(circle, rgba(30,77,140,0.3), transparent 65%); pointer-events: none; }
  .ev-cta-inner h2 { font-size: clamp(1.9rem, 3.5vw, 2.8rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 16px; position: relative; z-index: 1; }
  .ev-cta-inner > p { font-size: 1.05rem; color: #94a3b8; max-width: 500px; margin: 0 auto 36px; line-height: 1.75; position: relative; z-index: 1; }
  .ev-cta-btns { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .ev-cta-primary { padding: 14px 30px; background: #c9931a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; box-shadow: 0 4px 18px rgba(201,147,26,0.4); }
  .ev-cta-primary:hover { background: #e0a820; transform: translateY(-1px); }
  .ev-cta-secondary { padding: 14px 30px; background: rgba(255,255,255,0.07); color: #cbd5e1; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ev-cta-secondary:hover { background: rgba(255,255,255,0.13); color: #fff; }
`;

const fadeUp = { initial: { opacity: 0, y: 28 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: '-40px' }, transition: { duration: 0.55 } };
const stagger = (i: number) => ({ ...fadeUp, transition: { duration: 0.5, delay: i * 0.09 } });

const sources = [
  { icon: '🏛️', cls: 'irs', title: 'IRS Records', desc: 'Your legal entity name and EIN must exactly match what the IRS has on file. Any abbreviation difference causes a validation failure.' },
  { icon: '🔖', cls: 'cage', title: 'CAGE Code Database', desc: 'Your Commercial and Government Entity code must be linked to the correct SAM.gov entity. Address and name mismatches between CAGE and SAM.gov block registration.' },
  { icon: '🗃️', cls: 'sam', title: 'SAM.gov Internal Records', desc: "Your entity's internal data must be consistent across all sections of the SAM.gov profile — entity info, certifications, and financial data." },
  { icon: '🏢', cls: 'state', title: 'State Incorporation Records', desc: 'Your business entity must be in good standing with its state of incorporation. Dissolved, expired, or suspended entities cannot pass federal validation.' },
];

const errorTypes = [
  { icon: '📋', title: 'Legal Name Mismatch', desc: 'The entity name in SAM.gov does not exactly match the IRS-registered name. Missing punctuation, abbreviated words, or DBA usage instead of the legal name all cause failures.' },
  { icon: '🔢', title: 'EIN Errors', desc: 'Incorrect Employer Identification Number, or using a Social Security Number in place of an EIN, causes an immediate IRS validation failure that blocks the entire registration.' },
  { icon: '📍', title: 'Address Discrepancies', desc: 'The physical address in SAM.gov must match the address on file with the IRS and CAGE. Differences in suite numbers, ZIP codes, or street abbreviations trigger flags.' },
  { icon: '🔗', title: 'CAGE-to-UEI Linkage Errors', desc: 'The CAGE code must be correctly linked to your UEI in the SAM.gov system. Broken links or mismatched records prevent contract award processing.' },
  { icon: '📅', title: 'Expired Entity Status', desc: 'If your business registration with its state of formation has lapsed or been revoked, SAM.gov validation will fail because the entity is no longer legally active.' },
  { icon: '💳', title: 'EFT Banking Data Errors', desc: 'Incorrect Electronic Funds Transfer (EFT) information — wrong routing numbers, account numbers, or bank name — blocks all federal payments even after registration is active.' },
];

const checklistItems = [
  'Verify legal name against IRS EIN records (exact character match)',
  'Confirm EIN is valid and matches the registered business entity',
  'Cross-reference physical address with IRS, CAGE, and state records',
  'Validate CAGE code linkage to correct UEI in SAM.gov',
  'Confirm entity is in good standing with state of incorporation',
  'Audit EFT banking details for routing and account accuracy',
  'Check for duplicate registrations that trigger compliance flags',
  'Verify points of contact email addresses are current and valid',
  'Confirm NAICS codes match entity type and business description',
  'Review all representations for logical consistency',
];

const processSteps = [
  { title: 'Data Collection', desc: 'We gather your legal entity documents, EIN confirmation letter, CAGE records, state registration, and banking information.' },
  { title: 'Cross-Reference Audit', desc: 'We compare every data point across IRS, CAGE, state, and SAM.gov records — identifying every mismatch before submission.' },
  { title: 'Discrepancy Resolution', desc: 'We correct identified mismatches, updating records at the source (IRS, CAGE, state) where necessary, and in the SAM.gov profile.' },
  { title: 'Validation Confirmation', desc: 'We submit and monitor through the full SAM.gov validation pipeline, confirming clean validation and active status.' },
];

const EntityValidation: React.FC = () => {
  const { navigateTo } = useNavigation();

  return (
    <>
      <style>{styles}</style>
      <div className="ev-page">

        <div className="ev-breadcrumb">
          <button className="ev-breadcrumb-btn" onClick={() => navigateTo('')}>← SAM.gov Registration</button>
          <span>/</span>
          <span>Entity Validation</span>
        </div>

        {/* Hero */}
        <section className="ev-hero">
          <div className="ev-hero-blob1" />
          <div className="ev-hero-blob2" />
          <div className="ev-hero-inner">
            <motion.div {...fadeUp}>
              <div className="ev-badge">🔍 Pre-Registration Audit</div>
              <h1>
                Stop Errors Before They{' '}
                <span className="ev-gradient">Block Your Federal Business</span>
              </h1>
              <p className="ev-hero-sub">
                Data mismatches between SAM.gov, IRS, CAGE, and state records are the
                #1 cause of registration rejections and federal payment blocks. Our entity
                validation audit catches every discrepancy before it becomes a crisis.
              </p>
              <div className="ev-btn-group">
                <button className="ev-btn-primary">Audit My Entity Data →</button>
                <button className="ev-btn-secondary">Talk to a Specialist</button>
              </div>
            </motion.div>

            <motion.div className="ev-hero-right" initial={{ opacity: 0, x: 36 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.65, delay: 0.2 }}>
              <div className="ev-val-card">
                <div className="ev-val-dots" />
                <div className="ev-val-header">Entity Validation Audit — Results</div>
                {[
                  { icon: '✓', cls: 'ok', field: 'Legal Name (IRS Match)', status: 'Verified', statusCls: 'ok' },
                  { icon: '✓', cls: 'ok', field: 'EIN Cross-Reference', status: 'Verified', statusCls: 'ok' },
                  { icon: '⚠', cls: 'warn', field: 'CAGE Address vs. IRS Address', status: 'Mismatch', statusCls: 'warn' },
                  { icon: '✗', cls: 'err', field: 'EFT Routing Number', status: 'Invalid', statusCls: 'err' },
                  { icon: '✓', cls: 'ok', field: 'State Entity Status', status: 'Active', statusCls: 'ok' },
                  { icon: '✓', cls: 'ok', field: 'UEI–CAGE Linkage', status: 'Verified', statusCls: 'ok' },
                ].map((r, i) => (
                  <div key={i} className="ev-val-row">
                    <div className={`ev-val-icon ${r.cls}`}>{r.icon}</div>
                    <span className="ev-val-field">{r.field}</span>
                    <span className={`ev-val-status ${r.statusCls}`}>{r.status}</span>
                  </div>
                ))}
                <div className="ev-val-footer">
                  ✅ 2 issues found and corrected before submission. Registration approved without rejection.
                </div>
              </div>
              <div className="ev-score-card">
                <div className="ev-score-icon">🛡️</div>
                <div>
                  <div className="ev-score-label">Post-Audit Validation Rate</div>
                  <div className="ev-score-value">98% First-Submission Approval</div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* What Validation Is */}
        <section className="ev-section ev-what-bg">
          <div className="ev-container">
            <div className="ev-what-layout">
              <motion.div className="ev-what-left" {...fadeUp}>
                <div className="ev-kicker">What It Is</div>
                <h2>Entity Validation: Aligning Your Data Across All Federal Systems</h2>
                <p>
                  SAM.gov does not issue registrations based on what you type — it validates every
                  piece of information against four independent federal and government data sources.
                  Any discrepancy triggers a rejection or compliance flag.
                </p>
                <p>
                  Our validation audit cross-references your business data against all four sources
                  before submission — identifying and resolving every conflict so your registration
                  is approved the first time.
                </p>
                <div className="ev-sources">
                  {sources.map((s, i) => (
                    <div key={i} className="ev-source">
                      <div className={`ev-source-icon ${s.cls}`}>{s.icon}</div>
                      <div>
                        <h5>{s.title}</h5>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>

              <motion.div {...stagger(1)}>
                <div className="ev-mismatch-examples">
                  <div className="ev-mismatch-title">Common Mismatch Examples</div>
                  {[
                    { err: 'NAME', desc: '"Acme Corp" in SAM.gov vs. "Acme Corporation" at IRS — causes name mismatch rejection.' },
                    { err: 'ADDRESS', desc: '"Suite 100" in SAM.gov vs. "Ste 100" in CAGE — triggers address validation flag.' },
                    { err: 'EIN', desc: 'EIN entered with dashes vs. without — causes IRS cross-reference failure.' },
                    { err: 'CAGE', desc: 'CAGE code linked to old address not yet updated after office move — blocks activation.' },
                    { err: 'EFT', desc: 'Bank routing number with a transposed digit — federal payments blocked after award.' },
                    { err: 'STATE', desc: 'State registration expired 2 years ago — entity fails legal status validation.' },
                  ].map((r, i) => (
                    <div key={i} className="ev-mismatch-row">
                      <span className="ev-mismatch-err">{r.err}</span>
                      <span className="ev-mismatch-desc">{r.desc}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Error Types */}
        <section className="ev-section ev-errors-bg">
          <div className="ev-errors-glow" />
          <div className="ev-container">
            <motion.div className="ev-section-header" {...fadeUp}>
              <div className="ev-kicker">Root Causes</div>
              <h2>The 6 Most Common Validation Errors</h2>
              <p>These are the errors we find most frequently during entity audits — and the ones most likely to cause registration rejection or payment delays.</p>
            </motion.div>
            <div className="ev-errors-grid">
              {errorTypes.map((e, i) => (
                <motion.div key={i} className="ev-err-card" {...stagger(i)}>
                  <div className="ev-err-icon">{e.icon}</div>
                  <h4>{e.title}</h4>
                  <p>{e.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Audit Checklist + Process */}
        <section className="ev-section ev-audit-bg">
          <div className="ev-container">
            <div className="ev-audit-layout">
              <motion.div className="ev-audit-left" {...fadeUp}>
                <div className="ev-kicker">Our Audit</div>
                <h2>10-Point Entity Validation Checklist</h2>
                <p>
                  Our pre-registration audit covers every data point that SAM.gov validates
                  against external sources. Nothing is assumed. Every field is verified before
                  we submit.
                </p>
                <div className="ev-checklist">
                  {checklistItems.map((item, i) => (
                    <div key={i} className="ev-check-item">
                      <div className="ev-check-mark">✓</div>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </motion.div>

              <motion.div {...stagger(1)}>
                <div className="ev-kicker">Our Process</div>
                <div style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', fontWeight: 800, color: '#0c1a36', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '28px' }}>
                  How We Eliminate Errors
                </div>
                <div className="ev-process-right">
                  {processSteps.map((s, i) => (
                    <div key={i} className="ev-proc-step">
                      <div className="ev-proc-num">{String(i + 1).padStart(2, '0')}</div>
                      <div>
                        <h5>{s.title}</h5>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="ev-section ev-cta-bg">
          <div className="ev-container">
            <motion.div className="ev-cta-inner" {...fadeUp}>
              <div className="ev-cta-glow1" />
              <div className="ev-cta-glow2" />
              <h2>Audit Your Entity Data Before It Causes Problems</h2>
              <p>Our validation audit identifies every data conflict before submission — so your registration is approved the first time and your payments are never blocked.</p>
              <div className="ev-cta-btns">
                <button className="ev-cta-primary">Audit My Entity Data →</button>
                <button className="ev-cta-secondary">Schedule a Free Consultation</button>
              </div>
            </motion.div>
          </div>
        </section>

      </div>
    </>
  );
};

export default EntityValidation;
